// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/plunger-with-spring/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const plungerWithSpringEN: PageEntry = {
  id: "post.stoessel-mit-feder",
  locale: "en",
  slug: "plunger-with-spring",
  seo: {
    title: "Glossary: Plunger with spring explained simply | Dietz GmbH",
    description: "A plunger with spring is a component in mechanical systems that uses a spring in combination with a plunger or piston rod. This design makes it possible to convert spring force int",
  },
  type: "post",
  h1: "Glossary: Plunger with spring explained simply",
  intro: "A plunger with spring is a component in mechanical systems that uses a spring in combination with a plunger or piston rod. This design makes it possible to convert spring force into linear motion or to achieve mechanical damping. Spring plungers are used in various machines and devices, especially those that require precise control of movements. The selection of the appropriate spring and the correct tuning of the plunger mechanism are critical to the efficiency and performance of the overall system.",
  blocks: [

  ],
};
